import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function buildUrlWithParams(
    baseUrl: string,
    searchParams: Record<string, string | string[] | undefined>,
): string {
    const queryParams = new URLSearchParams();

    Object.entries(searchParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            if (key === 'search') {
                queryParams.append('q', value.toString());
            } else if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v !== undefined && v !== null && v !== '') {
                        queryParams.append(key, v.toString());
                    }
                });
            } else {
                queryParams.append(key, value.toString());
            }
        }
    });

    const queryString = queryParams.toString();
    return `${baseUrl}${queryString ? `?${queryString}` : ''}`;
}
